import { PageHeader } from "@components";

type InfractionsPageHeaderProps = {
	isConnecting?: boolean;
	onConnectCompany?: () => void;
};

export function InfractionsPageHeader({
	isConnecting = false,
	onConnectCompany,
}: InfractionsPageHeaderProps) {
	const handleConnectKeyDown = (event: React.KeyboardEvent) => {
		if (event.key === "Enter" || event.key === " ") {
			event.preventDefault();
			onConnectCompany?.();
		}
	};

	return (
		<PageHeader
			actions={
				!!onConnectCompany &&
				// <Button
				// 	aria-label="Conectar empresa"
				// 	color="secondary"
				// 	iconLeading={ShieldPlus}
				// 	isDisabled={isConnecting}
				// 	isLoading={isConnecting}
				// 	onClick={onConnectCompany}
				// 	onKeyDown={handleConnectKeyDown}
				// 	size="md"
				// 	tabIndex={0}
				// >
				// 	Conectar Empresa
				// </Button>
				null
			}
			data-slot="infractions-page-header"
			subtitle="Clique nos cards abaixo ou use a barra de filtros para visualizar a listagem específica das infrações"
			title="Gestão de Infrações"
		/>
	);
}
